export default __webpack_public_path__ + "static/media/presto.17d885f5.webp";